import Vue from 'vue';

export const isUserNotLoggedIn = async (to, from, next) => {
  try {
    const loggedInUser =
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
    if (loggedInUser && loggedInUser.signInUserSession) {
      if (to?.query?.redirect) {
        return next({
          path: to?.query?.redirect,
        });
      } else return next({ name: 'home', query: { section: 'data' } });
    }
    return next();
  } catch (error) {
    return next();
  }
};
